import { fetchDeviceListByUser, fetchDeviceSimpleInfo } from '@/api/device';

const deviceStore = {
  namespaced: true,
  state: {
    deviceList: [],
    deviceInfo: [],
    selectDeviceNameByUser: '',
    selectDeviceIpByUser: '',
    selectDeviceModeByUser: '',
    selectDeviceStatus: '',
  },
  getters: {},
  mutations: {
    allDevice(state, entitys) {
      state.deviceList = entitys;
    },
    selectedDevice(state, entitys) {
      state.deviceInfo = entitys;
      state.selectDeviceNameByUser = entitys[0].deviceName;
      state.selectDeviceIpByUser = entitys[0].deviceIp;
      state.selectDeviceModeByUser = entitys[0].deviceMode;
      state.selectDeviceStatus = entitys[0].deviceStatus;
    },
    deviceResetState(state) {
      state.deviceList = [];
      state.deviceInfo = [];
      state.selectDeviceNameByUser = '';
      state.selectDeviceIpByUser = '';
      state.selectDeviceModeByUser = '';
      state.selectDeviceStatus = '';
    },
  },
  actions: {
    async DeviceList({ commit }, Obj) {
      const { data } = await fetchDeviceListByUser(Obj);
      commit('allDevice', data.entitys);
      return data;
    },
    async DeviceInfo({ commit }, Obj) {
      const { data } = await fetchDeviceSimpleInfo(Obj);
      commit('selectedDevice', data.entitys);
      return data;
    },
  },
};

export { deviceStore };
